import { __awaiter } from "tslib";
import { notes } from "@phoenixreisen/mithrils/src/notification";
import { getCustomer } from "../../../shared/functions/fns.travel";
import { authCustomer } from "../../../shared/functions/fns.auth";
import { isValidInput } from "@phoenixreisen/form/src/functions";
import { int } from "@phoenixreisen/form/src/fields";
import Model from "../model";
import m from "mithril";
const submit = (state, attrs, e) => __awaiter(void 0, void 0, void 0, function* () {
    const { parent } = attrs;
    const { form } = state;
    e === null || e === void 0 ? void 0 : e.preventDefault();
    if (isValidInput(form)) {
        try {
            state.spinner = true;
            const auth = yield authCustomer(form.customerid.value(), form.postcode.value());
            const customer = yield getCustomer(form.customerid.value(), auth.jwt);
            parent.auth = auth;
            parent.customer = customer;
        }
        catch (_a) {
            notes.add({
                status: "error",
                text: "Bitte prüfen Sie Ihre Eingaben.",
            });
        }
        state.spinner = false;
        m.redraw();
    }
});
export default {
    oninit({ state }) {
        state.form = {
            customerid: int(),
            postcode: int(),
        };
        state.spinner = false;
    },
    view({ state, attrs }) {
        const { webtexte } = Model;
        const { form, spinner } = state;
        return (m("article", { class: "abo-catalog-form" },
            m("div", null, (webtexte === null || webtexte === void 0 ? void 0 : webtexte["katalogverwaltung__abonnements__text"]) ? (m.trust(webtexte === null || webtexte === void 0 ? void 0 : webtexte["katalogverwaltung__abonnements__text"])) : (m("p", null, "Nach Eingabe Ihrer Kundennummer sowie Ihrer Postleitzahl gelangen Sie zur Aufstellung Ihrer Abonnements."))),
            m("form", { onsubmit: (e) => submit(state, attrs, e) },
                m("label", { class: "textfield" },
                    m("input", { type: "text", maxlength: "7", name: "customerid", autocomplete: "customerid", placeholder: "z.B. 1234567", value: form.customerid.value(), oninput: (e) => form.customerid.validate(e.target.value) }),
                    m("span", { class: `textfield__label ${form.customerid.complaint ? "alert--warning" : ""}` }, "Kundennummer")),
                m("label", { class: "textfield" },
                    m("input", { type: "text", name: "postcode", maxlength: "10", autocomplete: "postcode", placeholder: "z.B. 53115", value: form.postcode.value(), oninput: (e) => form.postcode.validate(e.target.value) }),
                    m("span", { class: `textfield__label ${form.postcode.complaint ? "alert--warning" : ""}` }, "Postleitzahl")),
                m("div", { class: "mb0 mb3-ns" },
                    m("button", { type: "submit", disabled: spinner },
                        spinner && m("i", { class: "fas fa-spinner fa-spin mr2" }),
                        "Auswahl anzeigen")))));
    },
};
